import OPDIntegrations from "./Pages/Integrations";
import OPDSettings from "./Pages/Settings";

class OP3Dashboard {
    constructor() {
        this.integrations = new OPDIntegrations();
        this.settings = new OPDSettings();
    }
}

export default OP3Dashboard;


// WEBPACK FOOTER //
// ./resources/assets/js/OP3Dashboard.js